// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style_buttons__Rgr3f","active":"style_active__QEnq7"};